import { render, staticRenderFns } from "./form-row.vue?vue&type=template&id=3de65d47&"
import script from "./form-row.vue?vue&type=script&lang=js&"
export * from "./form-row.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports